import { useTranslation } from 'react-i18next';

export const RequiredLegend = () => {
  const { t } = useTranslation('common');
  return (
    <p id="required-legend">
      {t('common:fieldIsRequired')}(<span className="red">*</span>){' '}
      {t('common:fieldIsRequiredTwo')}
    </p>
  );
};
